import React, { Component } from "react";
import InputRange from "react-input-range";
import { connect } from "react-redux";
import { getSigleCurrency } from "../../store/actions/singleCurrencyActions";

import "./style.scss";

class SearchFilterComp extends Component {
  constructor(props) {
    super(props);

    this.params = new URLSearchParams(this.props.urlPath.location.search);

    this.state = {
      sort: ["All", "Daily", "Monthly", "Discount"],
      sortby: ["Popular", "Latest", "Low To High", "High To Low"],
      purpose: { 0: "All", 1: "Desk", 2: "Meeting Room", 4: "Cafe" },
      show_map: false,
      filters: {
        price: { min: 0, max: this.props.maxValue },
        attendees: { min: 0, max: this.props.maxValueAttendees },
        sort: "All",
        sortby: "Popular",
        amenities: [],
        nearby: [],
        purpose: 0,
        currency: "1"
      },
      buttons: {
        purpose: false,
        currency: false,
        price: false,
        more: false
      },
      isMobileFilter: false
    };
  }

  componentDidMount() {
    let getCurrency = this.params.get("currency");

    if (getCurrency) {
      let filters = this.state.filters;
      filters["currency"] = getCurrency;
      this.setState({
        filters
      });
      // Dispatch
      this.props.getSigleCurrency(getCurrency);
    } else {
      // Dispatch
      let curr = localStorage.getItem("O_Auth")
        ? JSON.parse(localStorage.getItem("O_Auth"))
        : "";

      if (curr === "") {
        this.props.getSigleCurrency(1);
      } else {
        this.props.getSigleCurrency(curr["currency"]);
      }
    }

    if (this.props.searchPath !== "") {
      let getPurpose = this.params.get("purpose");
      let getPrice = this.params.get("price");
      let getSort = this.params.get("sort");
      let getSortby = this.params.get("sortby");
      let getAmenities = this.params.get("amenities");
      let getAttendees = this.params.get("attendees");
      let getMap = this.params.get("map");
      let filters = this.state.filters;

      if (getMap) {
        this.setState({
          show_map: true
        });
      }

      if (getPurpose) {
        filters.purpose = getPurpose;
      }

      if (getPrice) {
        filters.price.min = parseInt(getPrice.split(",")[0]);
        filters.price.max = parseInt(getPrice.split(",")[1]);
      }

      if (getSort) {
        filters.sort = getSort;
      }

      if (getSortby) {
        filters.sortby = getSortby;
      }

      if (getAmenities) {
        filters.amenities = JSON.parse("[" + getAmenities + "]")
          .join()
          .split(",");
      }

      if (getAttendees) {
        filters.attendees.min = parseInt(getAttendees.split(",")[0]);
        filters.attendees.max = parseInt(getAttendees.split(",")[1]);
      }
    }
  }

  handleFilter = (value, key) => {
    if (key === "price") {
      if (value.min >= 0 && value.max <= this.props.maxValue) {
        this.handleDefaultFilter(value, key);
      }
    } else if (key === "attendees") {
      if (value.min >= 0 && value.max <= this.props.maxValueAttendees) {
        this.handleDefaultFilter(value, key);
      }
    } else {
      this.handleDefaultFilter(value, key);
    }
  };

  // default_ state assign
  handleDefaultFilter = (filter, key) => {
    let filters = this.state.filters;

    if (key === "amenities" || key === "nearby") {
      let id = filters[key].indexOf(filter);

      if (id !== -1) {
        filters[key].splice(id, 1);
      } else {
        filters[key] = [...filters[key], filter];
      }
    } else {
      filters[key] = filter;
    }

    this.setState({
      filters
    });
  };

  handleFilterButton = button => {
    let buttons = this.state.buttons;
    buttons[button] = !buttons[button];
    this.setState({ buttons });
    Object.keys(buttons).forEach(result => {
      if (button !== result) {
        this.setState(prevState => ({
          buttons: {
            ...prevState.buttons,
            [result]: false
          }
        }));
      }
    });
  };
  handleMapButton = () => {
    let show_map = this.state.show_map;

    if (show_map) {
      this.setState({ show_map: false });
      // remove url
      this.props.removeParamsInUrl("map");
      if (window.innerWidth > 767) {
        this.props.removeParamsInUrl("page");
      }
    } else {
      this.props.setParamsInUrl("map", "show");
      // this.props.removeParamsInUrl("page");
    }

    // Hide all filter buttons show
    let buttons = this.state.buttons;

    Object.keys(buttons).forEach(result => {
      this.setState({
        buttons: {
          [result]: false
        }
      });
    });
  };

  handleChangeFilter = (filter, key) => {
    this.props.removeParamsInUrl("page");
    let filters = this.state.filters;
    filters[key] = filter;

    this.setState(
      {
        filters
      },
      this.props.setParamsInUrl(key, filters[key])
    );
  };

  // Apply filter
  handleApplyFilter = key => {
    let filters = this.state.filters;

    this.props.removeParamsInUrl("page");

    if (key === "purpose") {
      // Set url
      this.props.setParamsInUrl(key, filters[key]);
    }

    if (key === "currency") {
      // Dispatch
      this.props.getSigleCurrency(filters[key]);

      // remove url
      this.props.removeParamsInUrl("price");
      // Set url
      this.props.setParamsInUrl(key, filters[key]);
    }

    if (key === "price") {
      let price = `${filters[key].min + "," + filters[key].max}`;
      // Set url
      this.props.setParamsInUrl(key, price);
    }

    if (key === "more") {
      let keys = ["sort", "amenities", "attendees"];

      for (let i = 0; i < keys.length; i++) {
        filters[keys[i]] = filters[keys[i]];

        let check = false;

        if (keys[i] === "sort") {
          if (this.params.get("sort")) {
            if (filters["sort"] === "All") {
              this.props.removeParamsInUrl("sort");
            } else {
              check = true;
            }
          } else {
            if (filters["sort"] !== "All") {
              check = true;
            }
          }
        }

        if (keys[i] === "amenities") {
          if (filters[keys[i]].length > 0) {
            check = true;
          } else {
            this.props.removeParamsInUrl("amenities");
          }
        }

        if (keys[i] === "attendees") {
          if (this.params.get("attendees")) {
            if (filters[keys[i]].min === 0 && filters[keys[i]].max === 500) {
              this.props.removeParamsInUrl("attendees");
            } else {
              filters[keys[i]] = `${filters[keys[i]].min +
                "," +
                filters[keys[i]].max}`;
              check = true;
            }
          } else {
            if (filters[keys[i]].min !== 0 || filters[keys[i]].max !== 500) {
              filters[keys[i]] = `${filters[keys[i]].min +
                "," +
                filters[keys[i]].max}`;
              check = true;
            }
          }
        }

        if (check) {
          this.props.setParamsInUrl(keys[i], filters[keys[i]]);
        }
      }
    }

    // Filter popup hide
    this.handleFilterButton(key);
  };

  handleResetFilter = key => {
    let filters = this.state.filters;

    if (key === "more") {
      filters["sort"] = "All";
      filters["amenities"] = [];
      filters["attendees"] = { min: 0, max: this.props.maxValueAttendees };
    } else {
      if (!this.params.get("map")) {
        this.props.removeParamsInUrl("page");
      }
      this.props.removeParamsInUrl(key);
    }

    this.setState({
      filters
    });
  };

  isMobileFilter = () => {
    let buttons = this.state.buttons;
    buttons["purpose"] = false;
    buttons["currency"] = false;
    buttons["price"] = false;
    buttons["more"] = false;
    this.setState({ buttons, isMobileFilter: !this.state.isMobileFilter });
  };

  render() {
    return (
      <div className="search_filter" id="search_filter_tab">
        <div
          className={`filter_heading ${
            this.state.isMobileFilter ? "active" : ""
          }`}
        >
          <div>
            <button
              onClick={() => this.handleFilterButton("purpose")}
              className={
                this.state.buttons.purpose || this.params.get("purpose")
                  ? "active"
                  : ""
              }
            >
              Purpose
            </button>
            <button
              onClick={() => this.handleFilterButton("currency")}
              className={
                this.state.buttons.currency || this.params.get("currency")
                  ? "active"
                  : ""
              }
            >
              Currency
            </button>
            <button
              onClick={() => this.handleFilterButton("price")}
              className={
                this.state.buttons.price || this.params.get("price")
                  ? "active"
                  : ""
              }
            >
              Price
            </button>
            <button
              onClick={() => this.handleFilterButton("more")}
              className={
                this.state.buttons.more ||
                this.params.get("sort") ||
                this.params.get("attendees") ||
                this.params.get("amenities")
                  ? "active"
                  : ""
              }
            >
              More Filter
            </button>
          </div>
          <div>
            <label
              className={`filter_btn ${
                this.params.get("purpose") ||
                this.params.get("currency") ||
                this.params.get("price") ||
                this.params.get("more")
                  ? "active"
                  : ""
              }`}
              onClick={this.isMobileFilter}
            >
              <i className="fa fa-filter"></i>
              Filter
            </label>

            <label className="check_list">
              <input
                onChange={() => this.handleMapButton()}
                type="checkbox"
                checked={this.state.show_map ? "checked" : ""}
              />
              <span className="checkmark"></span>
              Map
            </label>

            <select
              className="sort_by"
              onChange={e => this.handleChangeFilter(e.target.value, "sortby")}
              value={this.state.filters.sortby}
            >
              {this.state.sortby.map((value, i) => (
                <option key={i} value={value}>
                  {value}
                </option>
              ))}
            </select>
          </div>
        </div>

        {this.state.buttons.purpose ? (
          <div className="filter_block">
            <div className="inner purpose">
              <div className="row">
                <select
                  onChange={e => this.handleFilter(e.target.value, "purpose")}
                  defaultValue={this.state.filters.purpose}
                >
                  {Object.keys(this.state.purpose).map((value, i) => (
                    <option key={i} value={value}>
                      {this.state.purpose[value]}
                    </option>
                  ))}
                </select>
                <div className="apply_btn">
                  <span onClick={() => this.handleResetFilter("purpose")}>
                    Clear
                  </span>
                  <span onClick={() => this.handleApplyFilter("purpose")}>
                    Apply
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {this.state.buttons.currency ? (
          <div className="filter_block">
            <div className="inner currency">
              <div className="row">
                <select
                  onChange={e => this.handleFilter(e.target.value, "currency")}
                  value={this.state.filters.currency}
                >
                  {this.props.currency.map((curr, i) => (
                    <option key={i} value={curr.id}>
                      {curr.code}
                    </option>
                  ))}
                </select>
                <div className="apply_btn">
                  <span onClick={() => this.handleResetFilter("currency")}>
                    Clear
                  </span>
                  <span onClick={() => this.handleApplyFilter("currency")}>
                    Apply
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {this.state.buttons.price ? (
          <div className="filter_block">
            <div className="inner price">
              <div className="row">
                <InputRange
                  formatLabel={value => `${this.props.codeOnly()} ${value}`}
                  maxValue={this.props.maxValue}
                  minValue={0}
                  value={this.state.filters.price}
                  onChange={value => this.handleFilter(value, "price")}
                />
                <div className="apply_btn">
                  <span onClick={() => this.handleResetFilter("price")}>
                    Clear
                  </span>
                  <span onClick={() => this.handleApplyFilter("price")}>
                    Apply
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {this.state.buttons.more ? (
          <div>
            <div className="filter_block more">
              <div className="inner">
                <div className="row">
                  <h3>SORTING</h3>
                  <div className="sorting">
                    {this.state.sort.map((value, i) => (
                      <div className="sort" key={i}>
                        <label className="check_list">
                          <input
                            type="radio"
                            name="sort_name"
                            value={value}
                            checked={
                              this.state.filters.sort === value ? "checked" : ""
                            }
                            onChange={() => this.handleFilter(value, "sort")}
                          />
                          <span className="checkmark radio" />
                          {value}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="row">
                  <h3>ATTENDEES</h3>
                  <InputRange
                    maxValue={this.props.maxValueAttendees}
                    minValue={0}
                    value={this.state.filters.attendees}
                    onChange={value => this.handleFilter(value, "attendees")}
                  />
                </div>

                <div className="row">
                  <h3>AMENITIES</h3>
                  {/* {console.log(this.state.filters.amenities)} */}
                  <div className="check_block">
                    {this.props.amenities.map((amenities, i) => (
                      <div key={i}>
                        <label className="check_list">
                          <input
                            type="checkbox"
                            checked={this.state.filters.amenities.includes(
                              amenities.id
                            )}
                            onChange={() =>
                              this.handleFilter(amenities.id, "amenities")
                            }
                          />
                          <span className="checkmark" />
                          {amenities.title}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                {/* <div className="row">
                  <h3>NEAR BY PLACES</h3>
                  <div className="check_block">
                    <div className="place">
                      <label className="check_list">
                        <input type="checkbox" />
                        <span className="checkmark" />
                        Pondicherry, India
                      </label>
                    </div>
                    <div className="place">
                      <label className="check_list">
                        <input type="checkbox" />
                        <span className="checkmark" />
                        Aarhus, Denmark
                      </label>
                    </div>
                    <div className="place">
                      <label className="check_list">
                        <input type="checkbox" />
                        <span className="checkmark" />
                        Table
                      </label>
                    </div>
                    <div className="place">
                      <label className="check_list">
                        <input type="checkbox" />
                        <span className="checkmark" />
                        Universe
                      </label>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            <div className="filter_footer">
              <div className="left">
                <button onClick={() => this.handleApplyFilter("more")}>
                  Show workspace
                </button>
              </div>
              <div className="right">
                <button onClick={() => this.handleResetFilter("more")}>
                  Reset Filter
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getSigleCurrency: currency => dispatch(getSigleCurrency(currency))
  };
};

export default connect(null, mapDispatchToProps)(SearchFilterComp);
